/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/heading-has-content */
/* Resolved at runtime, react-markdown fills the html node content */
import ReactMarkdown from "react-markdown"

export type MarkdownProps = {
	className?: string
	specificComponents?: Record<string, unknown>
	children?: string
}

export const Markdown: React.FC<MarkdownProps> = ({
	children,
	specificComponents = {},
	...rest
}) => {
	return (
		<ReactMarkdown
			components={{
				h1: ({ children }) => (
					<h1 className="c-h1 text-primary font-bold my-3">{children}</h1>
				),
				h2: ({ children }) => (
					<h2 className="c-h2 text-primary font-bold my-3">{children}</h2>
				),
				h3: ({ children }) => (
					<h3 className="c-h3 text-primary font-bold my-3">{children}</h3>
				),
				h4: ({ children }) => (
					<h4 className="c-h4 text-primary font-bold my-2">{children}</h4>
				),
				h5: ({ children }) => (
					<h5 className="c-h5 text-primary font-bold my-1">{children}</h5>
				),
				p: ({ children }) => <p className="my-1">{children}</p>,
				ul: ({ children }) => <ul className="mb-2">{children}</ul>,
				li: ({ children }) => <li className="mt-1 pl-3">{children}</li>,
				a: ({ href, children }) => (
					<a className="underline" target="_blank" rel="noopener noreferrer" href={href}>
						{children}
					</a>
				),
				em: ({ children }) => <span className="italic">{children}</span>,
				strong: ({ children }) => <span className="font-bold">{children}</span>,
				...specificComponents,
			}}
			{...rest}
		>
			{children}
		</ReactMarkdown>
	)
}
